<template>
  <section>
    <SectionPageHeader :page="page" class="mb-8"/>
    <div class="page-container tablet:grid tablet:grid-cols-2 tablet:gap-x-12">
      <ArticleReference
              v-for="(project, index) in projects"
              :key="index"
              :content="project!.Description as string"
              :item-key="(project!.Nom as string).toLowerCase()"
              :location="project.Localisation"
              :subtitle="`${project['Catégorie  général']} - ${project['Catégorie : onglet']}`"
              :title="project!.Projets as string"
              img-class="absolute t-0 l-0 w-full h-full max-w-none max-h-none object-cover"
              picture-class="block min-h-[300px] h-full relative overflow-hidden rounded-img bg-white/77"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";

const {
    page
} = defineProps<{
    page: PageCollectionItemBase;
}>();
const {data: projects} = await useFetch('/api/getCSV', {
    query: {
        file: 'reference-pro.csv',
    },
    default: () => []
});
</script>